import axios from "axios";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 商材 - 解約SMS一覧取得
export async function getProductCancellSMSs(id: string) {
  try {
    const path = "productCancellSMSs";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
  }
}

// 商材 - 解約SMS詳細取得
export async function getProductCancellSMS(id: string) {
  try {
    const path = "productCancellSMS";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    const detail = response.data.detail_data;
    return detail && detail.length > 0 ? detail[0] : undefined;
  } catch (error) {}
}

// 商材 - 解約SMS詳細編集
export async function putProductCancellSMS(editData: EditDataDifine) {
  try {
    const path = "productCancellSMS";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {}
}

// 商材 - 解約SMS登録
export async function postProductCancellSMS(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "productCancellSMS";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {}
}

// 商材 - 解約SMS削除
export async function deleteProductCancellSMS(id: string) {
  try {
    const path = "productCancellSMS";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {}
}
